define((require) => {
    const $               = require("jquery");
    const Configuration   = require("shared/services/Configuration");
    const Window          = require("shared/services/Window");
    const {Logger}          = require("shared/util/Logger");
    const EventDispatcher = require("shared/util/EventDispatcher");

    const log = new Logger("StatsD");

    /**
     * Base class for analytics tracking using our internal StatsD/Graphite setup.
     *
     * @author Bo Gotthardt
     * @author Sune Wettersteen
     * @class StatsDAnalytics
     * @constructor
     *
     * @param {String} bucket
     */
    class StatsDAnalytics {
        constructor(bucket) {
            this._bucket = bucket;
            this._listener = new EventDispatcher();
            // This is both used by the Editor and Viewer, even though they set up the statsD entirely different... :(
            if (Configuration.trackErrors) {
                this._windowErrorListenerRemover = Window.error(this.trackError.bind(this)).off;
            }

            // Bind methods to StatsDAnalytics class
            // so they can use 'this' correctly
            this.trackEvent = this.trackEvent.bind(this);
            this.trackError = this.trackError.bind(this);
            this.trackFrontEndError = this.trackFrontEndError.bind(this);
            this.trackPageView = this.trackPageView.bind(this);
        }

        // eslint-disable-next-line class-methods-use-this
        trackEvent() {
            // Empty on purpose.
        }

        trackError() {
            this._send("error");
        }

        trackFrontEndError(errorType) {
            this._send(`frontendError. ${(errorType || "unknown")}`, null, null, null, true);
        }

        trackPageView() {
            this._send("pageview");
        }

        trackInitTime(loadTime) {
            this._send("init", "time", loadTime);
        }

        trackLoadTime(loadTime) {
            this._send("loaded", "time", loadTime);
        }

        track(path, value) {
            this._send(path, null, value);
        }

        // eslint-disable-next-line class-methods-use-this
        _getPathSuffix() {
            return "";
        }

        _send(path, type, value, suffix, ignoreSuffix) {
            path  = (`${this._bucket}.${path}${(ignoreSuffix ? "" : this._getPathSuffix()) + (suffix || "")}`).replace(/\s/g, "_");
            type  = type || "counter"; // counter, gauge or time
            value = value || 1;

            log.verbose(`StatsD request (path, type, value): (${path}, ${type}, ${value})`);

            $.ajax({
                url:  Configuration.statsDUrl,
                type: "POST",
                data: {
                    p: path,
                    t: type,
                    v: value
                }
            });
        }

        dispose() {
            this._listener.stopListening();

            if (this._windowErrorListenerRemover) {
                this._windowErrorListenerRemover();
            }
        }
    }

    return StatsDAnalytics;
});



// WEBPACK FOOTER //
// ./src/shared/services/tracker/StatsDAnalytics.js